var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _rect7, _rect8, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEssentiaGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1432",
    "data-name": "Grupo 1432",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.455,
    height: 55,
    viewBox: "0 0 162.455 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1036",
    "data-name": "Ret\\xE2ngulo 1036",
    width: 162.455,
    height: 55,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1027",
    "data-name": "Ret\\xE2ngulo 1027",
    width: 1.259,
    height: 1.262,
    transform: "translate(21.265 31.059) rotate(-45)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1028",
    "data-name": "Ret\\xE2ngulo 1028",
    width: 1.262,
    height: 1.259,
    transform: "translate(30.169 32.845) rotate(-45)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1029",
    "data-name": "Ret\\xE2ngulo 1029",
    width: 1.259,
    height: 1.259,
    transform: "translate(26.609 29.281) rotate(-45)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1030",
    "data-name": "Ret\\xE2ngulo 1030",
    width: 1.259,
    height: 1.259,
    transform: "translate(26.61 25.719) rotate(-45)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1031",
    "data-name": "Ret\\xE2ngulo 1031",
    width: 1.262,
    height: 1.259,
    transform: "translate(23.048 22.158) rotate(-45)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1032",
    "data-name": "Ret\\xE2ngulo 1032",
    width: 1.259,
    height: 1.259,
    transform: "translate(24.829 27.5) rotate(-45)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_707",
    "data-name": "Caminho 707",
    d: "M30.748,23.741,23.74,30.749v9.909l7.008,7.008h9.91l7.008-7.008V30.749l-7.008-7.008Zm15.66,7.531h0v8.9h0v0l-1.259-1.259v0l-3.209-3.209.89-.891,2.319,2.319V31.792l-4.1-4.1-2.671,2.671.888.887,1.781-1.78,0,0,.888.888.893.893.89.89-2.67,2.67h0l-1.783-1.783-.891.891L40.154,35.7l-.89.89-.891.89.891.891.888-.888.89-.891.891.891L44.6,40.157l0,0,.891.89-5.363,5.363H31.229l1.259-1.259h0L35.7,41.939l.89.89-2.319,2.319h5.343l4.1-4.1-2.672-2.672-.888.888,1.781,1.781,0,0-.888.888-1.783,1.783-2.67-2.67h0l1.783-1.783-.89-.89L35.7,40.155l-.891-.891-.89-.89-.89.89,1.778,1.779-3.562,3.562,0,0-.891.89L25,40.134v-8.9h0v0l1.259,1.259v0L29.467,35.7l-.891.891-2.318-2.319v5.342l4.1,4.1,2.671-2.671-.888-.888L30.36,41.936l-.89-.891-.893-.893-.891-.89,2.67-2.67h0l1.783,1.783.891-.891L31.251,35.7l.89-.891.891-.89-.891-.891-.888.888-.89.891-.891-.891L26.8,31.249h0l-.89-.889L31.271,25h8.906l-1.259,1.259h0l-3.209,3.209-.89-.89,2.318-2.319H31.791l-4.1,4.1,2.672,2.672.888-.889-1.781-1.78,0,0,2.671-2.671h0l2.67,2.67h0l-1.783,1.783.89.891L35.7,31.251l.89.891.891.891.89-.891L36.6,30.363,40.157,26.8l0,0,.891-.89Z",
    transform: "translate(-8.203 -8.203)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_708",
    "data-name": "Caminho 708",
    d: "M14.278,32.977V22.023l7.745-7.745H32.977l7.745,7.745V32.977l-7.745,7.745H22.023ZM55,1.31H161.146V53.69H55ZM0,0V55H162.455V0Z",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1033",
    "data-name": "Ret\\xE2ngulo 1033",
    width: 1.259,
    height: 1.259,
    transform: "translate(28.39 27.5) rotate(-45)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1034",
    "data-name": "Ret\\xE2ngulo 1034",
    width: 1.259,
    height: 1.262,
    transform: "translate(31.952 23.939) rotate(-45)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_709",
    "data-name": "Caminho 709",
    d: "M105.139,36.109V25.63h7.416v1.916h-5.185v2.278h5.075v1.916h-5.075v2.436h5.185v1.932Z",
    transform: "translate(-36.328 -8.856)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1431",
    "data-name": "Grupo 1431",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1430",
    "data-name": "Grupo 1430",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_710",
    "data-name": "Caminho 710",
    d: "M120.679,32.852a4.6,4.6,0,0,0,3.331,1.414c1.226,0,1.823-.582,1.823-1.179,0-.785-.911-1.053-2.121-1.336-1.712-.392-3.912-.864-3.912-3.2,0-1.744,1.508-3.158,3.975-3.158a5.828,5.828,0,0,1,4.085,1.461l-1.242,1.634a4.47,4.47,0,0,0-3-1.147c-1.005,0-1.539.44-1.539,1.068,0,.707.88.927,2.089,1.21,1.728.393,3.928.911,3.928,3.236,0,1.916-1.367,3.362-4.2,3.362a6.036,6.036,0,0,1-4.446-1.666Z",
    transform: "translate(-41.274 -8.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_711",
    "data-name": "Caminho 711",
    d: "M136.262,32.852a4.6,4.6,0,0,0,3.331,1.414c1.226,0,1.823-.582,1.823-1.179,0-.785-.911-1.053-2.121-1.336-1.712-.392-3.912-.864-3.912-3.2,0-1.744,1.508-3.158,3.975-3.158a5.829,5.829,0,0,1,4.085,1.461L142.2,28.484a4.47,4.47,0,0,0-3-1.147c-1.005,0-1.54.44-1.54,1.068,0,.707.88.927,2.09,1.21,1.728.393,3.928.911,3.928,3.236,0,1.916-1.367,3.362-4.2,3.362a6.036,6.036,0,0,1-4.446-1.666Z",
    transform: "translate(-46.658 -8.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_712",
    "data-name": "Caminho 712",
    d: "M151.87,36.109V25.63h7.416v1.916H154.1v2.278h5.075v1.916H154.1v2.436h5.185v1.932Z",
    transform: "translate(-52.474 -8.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_713",
    "data-name": "Caminho 713",
    d: "M175.049,36.109l-5-7.038v7.038h-2.231V25.63h2.294l4.855,6.787V25.63H177.2V36.109Z",
    transform: "translate(-57.986 -8.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_714",
    "data-name": "Caminho 714",
    d: "M188.724,36.109V27.594h-3.064V25.63h8.358v1.963h-3.048v8.515Z",
    transform: "translate(-64.149 -8.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1035",
    "data-name": "Ret\\xE2ngulo 1035",
    width: 2.231,
    height: 10.479,
    transform: "translate(132.155 16.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_715",
    "data-name": "Caminho 715",
    d: "M216.934,36.109l-.66-1.807h-4.682l-.66,1.807h-2.451l4.053-10.479h2.8l4.037,10.479Zm-3-8.547-1.744,4.808h3.473Z",
    transform: "translate(-72.034 -8.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_716",
    "data-name": "Caminho 716",
    d: "M108.756,47.887a3.184,3.184,0,0,1,2.813,1.488l-1.2.652a1.931,1.931,0,0,0-1.611-.855,2.234,2.234,0,0,0,0,4.464,2.3,2.3,0,0,0,1.468-.52V52.29h-1.814V51.047h3.24v2.6a3.772,3.772,0,0,1-2.894,1.284,3.522,3.522,0,1,1,0-7.042",
    transform: "translate(-36.328 -16.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_717",
    "data-name": "Caminho 717",
    d: "M121.941,54.856l-1.335-2.435h-1.06v2.435H118.1v-6.8h3.179a2.117,2.117,0,0,1,2.283,2.191,1.95,1.95,0,0,1-1.488,2.018l1.528,2.588Zm-.877-5.553h-1.518v1.874h1.518a.941.941,0,1,0,0-1.874",
    transform: "translate(-40.805 -16.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_718",
    "data-name": "Caminho 718",
    d: "M132.409,47.888a3.515,3.515,0,1,1-3.545,3.515,3.416,3.416,0,0,1,3.545-3.515m0,1.284a2.238,2.238,0,1,0,2.069,2.231,2.055,2.055,0,0,0-2.069-2.231",
    transform: "translate(-44.525 -16.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_719",
    "data-name": "Caminho 719",
    d: "M142.526,48.058h1.467v4.036a1.57,1.57,0,1,0,3.139,0V48.058H148.6v4.076c0,1.692-.969,2.843-3.026,2.843-2.079,0-3.047-1.162-3.047-2.833Z",
    transform: "translate(-49.245 -16.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_720",
    "data-name": "Caminho 720",
    d: "M155.113,54.856v-6.8h3.178a2.183,2.183,0,1,1,0,4.361H156.56v2.435ZM158.1,49.3H156.56v1.874H158.1a.939.939,0,1,0,0-1.874",
    transform: "translate(-53.595 -16.605)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentiaGroup);
export default __webpack_public_path__ + "static/media/essentia-group.c3ab5e46516c19b416675a66df6c13bb.svg";
export { ForwardRef as ReactComponent };